<template>
  <div class="live-chat">
    <div v-if="false" id="live-chat-btn">
      <div
        class="image"
        @mousedown="$emit('changeDragLiveChatBtn', false)"
        @mouseup="showLiveChat"
        v-tooltip.bottom-end="'Chat với tư vấn viên'"
      ></div>
      <div class="hide" @click="hideLiveChatBtn"></div>
    </div>
    <div v-if="true" id="quick-icon">
      <div class="toggle" @click="toggleQuickIcon">
        <div
          :class="{
            'img img-show': isShowQuickIcon,
            'img img-hide': !isShowQuickIcon,
          }"
        ></div>
      </div>
      <ul
        ref="quickIcon"
        id="quick-icon-list"
        class="list-icon"
        :class="{ show: isShowQuickIcon, hide: !isShowQuickIcon }"
      >
        <li
          class="icon amis-support-chat"
          @click="showAmisSupportChat"
          v-tooltip.left="amisSupportTooltip"
        >
          <!-- Badge hiển thị số tin nhắn chưa đọc -->
          <div v-if="unreadCount > 0" class="unread-badge">
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </div>
        </li>
        <li
          v-tooltip.left="'MISA AVA'"
          class="icon misa-ava"
          id="ic-misa-ava"
          @click="showMISAAVA"
          v-show="isShowQuickIcon"
        />
      </ul>
    </div>
  </div>
</template>

<script>
//import DragSelect from "dragselect";
import { TourGuideKey } from '@/commons/enumTourGuide.js';
import { useTourGuide } from '@/setup/tourGuideComposition.js';
import { MsPopoverPosition } from '@/lib/vueFinalPopover/VueFinalPopover.vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { ModuleTourGuide } from '@/stores/moduleConst.js';
import {
  onMounted,
  onBeforeUnmount,
  computed,
  ref,
  reactive,
  watch,
  getCurrentInstance,
  handleError,
  inject,
  nextTick,
  defineEmits,
} from 'vue';
//
import { I18nInjectionKey } from 'vue-i18n';
import { createEventEmitter } from 'vue';
import amisSupportService from '@/commons/amisSupportService.js';

export default {
  name: 'LiveChat',
  components: {},

  props: {
    dragLiveChatBtn: {
      default: false,
      type: Boolean,
    },
  },

  setup() {
    const { tourGuideConfig, openTourGuide, isGettedData, tourLiveChat } =
      useTourGuide();
    const quickIcon = ref(null);
    const { t } = inject(I18nInjectionKey);
    const store = useStore();
    const router = useRouter();

    // AMISSUPORT reactive data
    const unreadCount = ref(0);
    const latestMessage = ref(null);
    const amisSupportReady = ref(false);

    // Computed cho tooltip
    const amisSupportTooltip = computed(() => {
      if (!amisSupportReady.value) {
        return 'Đang kết nối chat support...';
      }

      if (unreadCount.value > 0 && latestMessage.value) {
        return amisSupportService.getLatestMessageForTooltip();
      }

      return 'Chat với tư vấn viên';
    });

    onMounted(async () => {
      // Khởi tạo AMIS Support
      await initializeAmisSupport();

      nextTick(() => {
        tourGuideConfig.value;
        if (tourLiveChat.value) {
          openTourGuideLiveChat();
        }
      });
    });

    /**
     * Khởi tạo AMIS Support với user info
     */
    const initializeAmisSupport = async () => {
      try {
        const userInfo = store.state?.context?.User || {};

        await amisSupportService.initializeChat({
          userId: userInfo.UserID || '',
          userName: userInfo.FullName || userInfo.UserName || '',
          userEmail: userInfo.Email || '',
          mobile: userInfo.Mobile || '',
          CompanyId: userInfo.TenantID || '',
          Company: userInfo.OrganizationName || '',
          CompanyCode:
            userInfo.TenantCode +
              '_' +
              userInfo.OrganizationCode +
              '_' +
              userInfo.OrganizationID || '',
        });

        // Setup event listeners
        amisSupportService.on('unreadCountChanged', (count) => {
          unreadCount.value = count;
        });

        amisSupportService.on('messageReceived', (message) => {
          latestMessage.value = message;
        });

        amisSupportReady.value = true;
        console.log(
          'AMIS Support initialized successfully in LiveChat component'
        );
      } catch (error) {
        console.error('Failed to initialize AMIS Support:', error);
        amisSupportReady.value = false;
      }
    };

    /**
     * Mở tour guide
     * @author: VDGiang(28/06/2023)
     */
    const openTourGuideLiveChat = () => {
      if (store.state['context'].User.IsAdmin) {
        const addUserRect = quickIcon.value
          ? quickIcon.value.getBoundingClientRect()
          : null;
        if (!addUserRect) return;
        const userListTourGuideSteps = [
          {
            key: TourGuideKey.LiveChat,
            width: addUserRect.width + 24,
            height: addUserRect.height,
            left: addUserRect.left - 12,
            top: addUserRect.top,
            position: {
              offsetX: 0,
            },
            title: t('i18nUserManager.Title.LiveChat'),
            msg: t('i18nManual.LiveChat.Mess'),
          },
        ];
        const userListTourGuideConfig =
          tourGuideConfig.value[TourGuideKey.LiveChat];
        const currentTourGuideStep = userListTourGuideConfig
          ? userListTourGuideConfig
          : 1;
        if (currentTourGuideStep > userListTourGuideSteps.length) return;

        openTourGuide(userListTourGuideSteps, currentTourGuideStep);
      }
    };

    watch(
      () => tourLiveChat.value,
      (newVal) => {
        if (newVal) openTourGuideLiveChat();
      },
      {
        flush: 'post',
      }
    );

    onBeforeUnmount(() => {
      store.commit(`${ModuleTourGuide}/closeTourGuide`);
      // Cleanup AMIS Support
      amisSupportService.destroy();
    });

    return {
      quickIcon,
      unreadCount,
      latestMessage,
      amisSupportReady,
      amisSupportTooltip,
    };
  },

  data() {
    return {
      isShowLiveChatBtn: false,
      isShowQuickAction: true,
      isShowQuickIcon: true,
      //   dragSelect: null,
    };
  },

  methods: {
    showMISAAVA() {
      window._aiBot.show();
    },

    showLiveChat() {
      if (!this.dragLiveChatBtn) {
        this.showAmisSupportChat();
      }
    },

    /**
     * Hiển thị AMIS Support Chat
     */
    showAmisSupportChat() {
      console.log('AMISSUPORT: showAmisSupportChat called');
      this.handleChatClick();
      this.isShowLiveChatBtn = false;
    },

    showLiveChatUnCheck() {
      this.showAmisSupportChat();
    },

    /**
     * Xử lý click chat button
     */
    handleChatClick() {
      console.log('AMISSUPORT: User clicked chat button');
      // Toggle chat window
      amisSupportService.toggleChat();
    },

    /**
     * Ẩn hiện qiuck icon
     */
    toggleQuickIcon() {
      this.isShowQuickIcon = !this.isShowQuickIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.live-chat {
  #live-chat-btn {
    position: fixed;
    bottom: 32px;
    right: 24px;
    height: 48px;
    width: 48px;
    cursor: pointer;
    z-index: 1000 !important;
    text-align: center;
    display: flex;
    align-items: center;

    .image {
      background-image: url($ms-image-ic_live_chat_btn);
      background-repeat: no-repeat;
      background-position: center;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      box-shadow: 0px 6px 16px rgb(0 0 0 / 20%);
    }

    // .hide {
    //   position: absolute;
    //   background-image: url($ms-image-ic_live_chat_hide);
    //   background-repeat: no-repeat;
    //   background-position: center;
    //   top: 2px;
    //   right: 2px;
    //   width: 12px;
    //   height: 12px;
    //   cursor: pointer;
    // }
  }
  #quick-icon {
    position: fixed;
    right: 0;
    top: 50%;
    -webkit-transform: translate(0, -50%) !important;
    transform: translate(0, -50%) !important;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: right;
    align-items: flex-end;
    .toggle {
      width: 16px;
      height: 32px;
      border-radius: 4px 0 0 4px;
      cursor: pointer;
      background-color: #2680eb;
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        position: absolute;
        background: url($ms-image-ic_toggle_quick) no-repeat;
        width: 5px;
        height: 8px;
        stroke-width: 2px;
        stroke: #fff;
        background-repeat: no-repeat;
        transition: 0.4s ease;
      }
      .img-show {
        transform: rotate(0deg);
      }
      .img-hide {
        transform: rotate(180deg);
      }
    }

    .list-icon {
      position: absolute;
      list-style: none;
      margin: 0;
      top: 36px;
      right: 0;
      display: flex;
      padding: 8px;
      flex-direction: column;
      align-items: flex-start;
      border-radius: 8px 0 0 8px;
      background: #fff;
      box-shadow: -4px 0 16px 0 rgba(0, 0, 0, 0.08);
      transition: width 0.4s ease;
      .icon {
        width: 40px;
        height: 42px;
        border-radius: 8px 0 0 8px;
        // background-color: #2680eb;
        margin: 4px 0;
        cursor: pointer;
        position: relative;
      }

      .amis-support-chat {
        background-image: url('@/assets/images/icons/amis-chat.png');
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.3sease;
        display: block;

        // Badge cho số tin nhắn chưa đọc
        .unread-badge {
          position: absolute;
          top: -2px;
          right: -2px;
          background-color: #ff4444;
          color: white;
          border-radius: 50%;
          min-width: 16px;
          height: 16px;
          font-size: 10px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
          z-index: 1;
        }
      }

      .live-chat {
        background-image: url($ms-image-ic_live_chat_quick);
        background-repeat: no-repeat;
        position: relative;
        background-color: #2680eb;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        background-repeat: no-repeat;
        cursor: pointer;
      }
    }

    .show {
      width: 56px;
    }

    .hide {
      width: 0px;
      display: none;
    }
    .misa-ava {
      background-image: url($ms-image-ic_misa_ava);
      background-repeat: no-repeat;
      position: relative;
      // background-color: #2680eb;
      // border-radius: 50%;
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
}
</style>
